import React, {useState, useEffect, useRef} from "react";

import "./Fading.css";

export default function TextVideo(props) {
  const width= window.innerWidth;

  const ref= useRef();
  
  useEffect(() => {
    const width= window.innerWidth;
  }, []);

  const json_object = JSON.parse(props.textVideo)
  return (
    props.isMobile ? (
    <div  style={{
        position: "relative",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "black", 
        }}>
      <video
        controls="controls"
        autoPlay={false}
        width=  {width>=1200 ? "50%":"100%"}
        src={json_object.src}
        preload="auto"
        onLoad={()=>{this.player.seek(0)}} 
        poster = {json_object.poster}
        />
    </div>)
    : (
      <div  style={{
        position: "relative",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "black", 
        }}>
      <video
        controls="controls"
        autoPlay={false}
        width=  {width>=1200 ? "50%":"100%"}
        src={json_object.src}
        preload="auto"
        onLoad={()=>{this.player.seek(0)}} 
        />
    </div>
    )
    )
}
